import { Component, Input, HostListener, ViewChild  } from '@angular/core';
import { Router } from '@angular/router';
import { GovHeaderComponent } from '../govHeader/govheader.component';
import { CommonModule } from '@angular/common';
import { LiquidarRETEICAComponent } from '../../../domains/liquidar_reteica/liquidar_reteica.component';
import { LiquidarICAComponent } from '../../../domains/liquidar_ica/liquidar_ica.component';
import { AuthService } from '../../../services/components/auth.servicice';
import { RITService } from '../../../services/http/rit.service';
import { RouterLink } from '@angular/router';
import { ModalComponent } from './../modal/modal.component';
import { ModalService } from './../../services/modal.service';
import { environment } from './../../../../environments/environment';

@Component({
  selector: 'ngx-gov-co-shd-app-header-auth',
  standalone: true,
  imports: [CommonModule,RouterLink, LiquidarICAComponent, LiquidarRETEICAComponent, GovHeaderComponent, ModalComponent ],
  templateUrl: './header_auth.component.html',
  styleUrls: ['./header_auth.component.css']
})
export class HeaderAuthComponent {

  private activeItem: HTMLElement | null = null; // Guarda el ítem bajo hover

  @ViewChild(LiquidarICAComponent) liquidarICAComponent!: LiquidarICAComponent;
  @ViewChild(LiquidarRETEICAComponent) liquidarRETEICAComponent!: LiquidarRETEICAComponent;


  @Input() menuElements: { ruta: string, alias: string }[] = [ {ruta: "/login", alias: "Inicio"}, {ruta: "/login", alias: "Mis impuestos"}, {ruta: "/login", alias: "Declarar y pagar"}, {ruta: "/login", alias: "Mi RIT"}];
  @Input() invisibleMenu: string [] = [];
  
  urlsIcons  = {
    ica: this.getAssetUrl('assets/icons/Property1ica.svg'),
    reteica: this.getAssetUrl('assets/icons/Property1reteica.svg'),
  }

  urlLogoHeader = this.getAssetUrl('assets/menu/logo-hacienda_header.svg');

  getAssetUrl(filename: string): string {
    return `${filename}?v=${Date.now()}`;
  }

  nameUser = "";
  constructor(public router: Router, private authService: AuthService, private rITService:RITService, private modalService:ModalService) {
    this.authService.getValueConfig();

    this.nameUser = String(this.authService.getNameUser());
    
  }

  getSiglas(){
    let text = this.nameUser.split(' ');
    let string = "";
    if(text.length >= 1 && text[0]){
      string = text[0].substring(0,1);
      if(text.length >= 2 && text[1]){
        string += text[1].substring(0,1);
      }
    }
    return string;
  }


  renderMenu(){
    if(this.invisibleMenu.includes(this.selectedMenu)){
      return [];
    }
    return this.menuElements;
  }

  selectedMenu = '';
  
  estadoBoton = false;

  ngOnInit() {
    if(window.innerWidth >= 991){
      this.estadoBoton = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if(window.innerWidth >= 991){
      this.estadoBoton = false;
    }
  }

  cambioEstadoMenu(){
    this.estadoBoton = !this.estadoBoton;
  }
  
  irARuta(ruta: string, select: string = ""){
    if(ruta.toLocaleLowerCase().indexOf("http") > -1){
      location.href = ruta;
    }else{
      this.selectedMenu = select;
      this.router.navigateByUrl('/'+ruta);
    }
  }

  liquitarICA(){
    this.liquidarICAComponent.enviar();
  }

  liquitarRETEICA(){
    this.liquidarRETEICAComponent.enviar();
  }
  
  cerrarSession(){
    sessionStorage.clear();
    this.authService.clearAll();
    this.router.navigate(['/login']);
  }

  getCifradoXLiquidadores(){    
    this.rITService.getCifradoXLiquidadores().subscribe({
      next: (response) => {
        if( response !== void 0 ) {
          window.open( environment.urlRegistroInfoTrib + response.valor);
        } else {
          this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Servicio no disponible, por favor intente más tarde");
        }
      },
      error: (err) => {
        this.modalService.mostrarMensaje(this.modalService.TIPO_MODAL.ERROR, "ERROR", "Error consultando la información del servidor");
      }
    });
  }

  /**
   * Muestra y posiciona el tooltip.
   */
  showTooltip(event: MouseEvent): void {
    const item = event.currentTarget as HTMLElement;
    this.activeItem = item; 
    this.updateTooltipPosition();
  }

  /**
   * FUNCIÓN CLAVE: Recalcula la posición del tooltip fijo.
   */
  updateTooltipPosition(): void {
    if (!this.activeItem) return;
    // 1. Obtener coordenadas del ÍTEM respecto a la ventana. 
    //    Este valor SÍ refleja el scroll interno del contenedor.
    const itemRect = this.activeItem.getBoundingClientRect();
    
    // 2. Calcular la coordenada Y centrado (el valor 'top' para el elemento fixed):
    //    Posición visible del tope del ítem + la mitad de la altura del ítem.
    const finalCenterTop = itemRect.top + (itemRect.height / 2);
    let textElement = this.activeItem.parentElement as HTMLElement;
    if(textElement){
      textElement = textElement?.querySelector('.tooltip-text') as HTMLElement;
      if(textElement) {
        textElement.style.top = `${finalCenterTop}px`;
        textElement.style.transform = 'translateY(-50%)'; 
      }
    }
  }

}
